import { environment } from './config/environment';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const msalConfig = {
  auth: {
    /* The Azure Portal/App Registration application id */
    clientId: environment.MICROSOFT_CLIENT_ID,
    /*
     * "/<tenantId>" | "/common" | "/organizations"
     * See https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/authority.md
     */
    authority: 'https://login.microsoftonline.com/organizations',
    /* Must register on Azure Portal/App Registration. Defaults to window.location.origin */
    redirectUri: '/auth/microsoft',
    navigateToLoginRequestUrl: false
  },
  cache: {
    /*
     *  "sessionStorage" | "localStorage"
     *  Can be "localStorage" since we only need this to fetch the token to send to the API
     */
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
};
export const loginRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account'
};
let msalInstancePromise;

/** Loads MSAL on first use and initializes it; await it before calling any MSAL API. */
export const getMsalInstance = () => {
  msalInstancePromise ??= import('@azure/msal-browser').then(async ({
    PublicClientApplication
  }) => {
    const instance = new PublicClientApplication(msalConfig);
    await instance.initialize();
    return instance;
  }).catch(error => {
    // A failed chunk load (flaky network, offline) must not stick: let the next sign-in retry.
    msalInstancePromise = undefined;
    throw error;
  });
  return msalInstancePromise;
};
let msalRedirectPromise;

/**
 * Process the MSAL redirect response once at app startup.
 * Must be called exactly once — subsequent calls return the cached result.
 */
export const processMsalRedirect = () => {
  msalRedirectPromise ??= getMsalInstance().then(msal => msal.handleRedirectPromise());
  return msalRedirectPromise;
};

/** Clears MSAL's accounts and the deduped redirect, loading MSAL if this page hasn't: its cache outlives reloads. */
export const clearMsalSession = async () => {
  msalRedirectPromise = undefined;
  const msal = await getMsalInstance();
  msal.setActiveAccount(null);
  for (const account of msal.getAllAccounts()) {
    await msal.clearCache({
      account
    });
  }
};